import React, { useState } from 'react';
import get from 'lodash/get';
import Head from 'next/head';
import Image from 'next/image';
import debounce from 'lodash/debounce';
import { toast } from 'react-toastify';
import axios from '../utils/ajax';
import Header from '../components/Header';
import HraderDeliveryAddress from '../components/HraderDeliveryAddress';

import categoriesHelper from '../helpers/categoriesHelper';
import InlineLoader from '../components/InlineLoader';
import ItemNotFound from '../components/ItemNotFound';
import Product from '../components/Product';
import CategoryMenu from '../components/DTC/CategoryMenu';

import * as SegmentSource from '../constants/segmentSource';

import { useLocationProductsCategory, useFullCategoryList } from '../hooks/Shop';
import Slider from '../components/CustomSlider';
import Loader from '../components/Loader';
import emailValidationWithError from '../helpers/emailValidationWithError';
import nameValidationWithError from '../helpers/nameValidationWithError';
import useAPI from '../NetworkCall/API';
import { DEFAULT_CATEGORY, DEFAULT_CATEGORY_2, DEFAULT_CATEGORY_MENU, DEFAULT_ZIPCODE } from '../constants/default';
import getHost from '../helpers/gethost';
import pageDisable from '../helpers/pageDisableHelper';

import trafficJunkyBanner from '../public/static/images/traffic-junky-banner1.jpg';
import trafficJunkyLogo from '../public/static/images/traffic-junky-logos.jpg';
import { useConfigData } from '../Context/ConfigProvider';
import { withConfig } from '../lib/withConfig';
// import appConfig from '../appConfig';

const la = 1;
const defaultSlug = process.env.NEXT_PUBLIC_ENV == 'production' ? DEFAULT_CATEGORY : DEFAULT_CATEGORY_2;

const productSliderDesktop = {
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 3,
  arrows: true,
  centerMode: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: true
      }
    }
  ]
};
const canonicalHref = `https://${getHost()}/dealhub2`;

const LosAngeles = ({ slug = defaultSlug, location = la, staticData, fullCategoriesList: initialFullCategoriesList }) => {
  const {
    data: { currentCategory },
    isLoading,
    isValidating
  } = useLocationProductsCategory({ slug, location, staticData });
  const fetching = isLoading || isValidating;
  const appConfig = useConfigData();
  const [errorMessage, setErrorMessage] = useState(null);
  const [showLoader, setShowLoader] = useState(false);
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');

  const { subscribeToDeals } = useAPI();
  const { data: fullCategoryList = DEFAULT_CATEGORY_MENU } = useFullCategoryList({ initialFullCategoriesList });

  function renderProducts(productDetails) {
    if (productDetails && productDetails.products) {
      return productDetails.products.map((item, productIndex) => {
        return (
          <Product
            page="ASAP List"
            productIndex={productIndex}
            categoryIndex={0}
            width50
            key={`product_list_${item.product_id}`}
            data={item}
            source={SegmentSource.shopPage}
            openInPopup
          />
        );
      });
    }
    return null;
  }

  const handleSubmit = debounce(
    async () => {
      const emailError = emailValidationWithError(email);
      const nameError = nameValidationWithError(name);
      if (nameError) {
        toast.error(nameError);
      } else if (emailError) {
        toast.error(emailError);
      } else {
        setShowLoader(true);
        await subscribeToDeals({ name, email });
        setErrorMessage(null);
        setShowLoader(false);
      }
    },
    2000,
    { leading: true, trailing: false }
  );

  function callSetName(e) {
    setName(e.target.value);
  }

  function callSetEmail(e) {
    setEmail(e.target.value);
  }

  const getUrl = ({ src, width }) => {
    return `${src}?w=${width}`;
  };

  return (
    <>
      <Head>
        <title>Los Angeles Weed Delivery ${appConfig.APP_NAME}</title>
        <meta name="description" content={`Los Angeles Weed Delivery ${appConfig.APP_NAME}`} />
        <link rel="canonical" href={canonicalHref} />
      </Head>
      <Header
        // hasShadow={isSolid}
        // hasWhiteBg={isSolid}
        backPath
        toPath="/"
        centerComponent={<HraderDeliveryAddress hideOnLarge />}
      />

      <div className="shop-full-menu traffic-junky-page">
        <CategoryMenu className="d-lg-none" fullCategoryList={fullCategoryList} />
        {/* <div className="location-banner">
          <a href="./">
            <Image className="img-fluid" width="1920" height="781" src={trafficJunkyBanner} loader={getUrl} />
          </a>
        </div> */}

        <section className="social-proofing">
          <div className="container two-rem-mt ">
            {isLoading ? (
              <div className="text-center my-2">
                <InlineLoader positionRelative className="big" />
              </div>
            ) : (
              <>
                <div className=" ">
                  {currentCategory && currentCategory.products ? (
                    <div>
                      <h1 className="text-primary bold  text-primary h-h1">Top Flower</h1>
                      <div className="all-products-slider relative row m-0 ">
                        <Slider {...productSliderDesktop}>{renderProducts(currentCategory)}</Slider>
                      </div>
                    </div>
                  ) : (
                    <>
                      <div className="one-rem-mt four-rem-mb">
                        <ItemNotFound text="No products found" />
                      </div>
                    </>
                  )}
                </div>
              </>
            )}
            <hr />
          </div>
        </section>
        <section className="best-brands mt-5">
          <div className="container">
            <h1 className="text-primary bold  text-primary h-h1">All The Best Brands</h1>
            <Image className="img-fluid" src={trafficJunkyLogo} loader={getUrl} />
          </div>
        </section>
        <div className="email-capture-form py-5">
          <div className="e-left-sec">
            <h5 className="mb-3 mb-lg-0"> Sign Up here for the best deals on {appConfig.APP_NAME} </h5>
          </div>

          <div className="e-right-sec">
            <input className="form-control" type="text" placeholder="Name" onChange={callSetName} />
            <input className="form-control" type="email" placeholder="Email" onChange={callSetEmail} />
            {showLoader ? (
              <Loader />
            ) : (
              <button type="button" className="btn btn-primary btn-junky mt-2 mt-lg-0" onClick={handleSubmit}>
                Submit
              </button>
            )}
          </div>

          <p className="red-color half-rem-mt">{errorMessage}</p>
        </div>
      </div>
    </>
  );
};

async function getStaticPropsFunction() {
  return { props: {} };
  if (process.env.NEXT_PUBLIC_CHECKOUT_ONLY === 'true') {
    return { props: {} };
  }

  const promiseArray = [];
  promiseArray.push(
    axios({
      url: `${process.env.NEXT_PUBLIC_SECURE_EC2_URL}/products/schedule/${defaultSlug}/location/${la}`,
      method: 'GET',
      headers: {}
    })
  );
  promiseArray.push(
    axios({
      url: `${process.env.NEXT_PUBLIC_SECURE_EC2_URL}/pre_fetch/logo`,
      method: 'GET',
      headers: { zc: DEFAULT_ZIPCODE }
    })
  );
  try {
    const response = await Promise.all(promiseArray);
    const fullCategoriesListResponse = response[1];
    const currentCategory = categoriesHelper(get(response[0], 'data.categories', []));
    const asapData = currentCategory.length ? currentCategory[0] : {};
    const fullCategoriesList = get(fullCategoriesListResponse, 'data', []);
    return { props: { slug: defaultSlug, location: la, asapData, fullCategoriesList }, revalidate: 10 };
  } catch (error) {
    console.error('LosAngeles', error);
    throw error;
  }
}
export const getStaticProps = withConfig(getStaticPropsFunction)
export default pageDisable(LosAngeles);
